<template>

        <!--<h1 class="h1 mb-4">Deals</h1>-->
<!--<p class="text-xl text-gray-400">Filters:</p>-->
<div class="w-full flex flex-col text-gray-500 pt-4">
    <div class="overflow-x-auto">
        <div class="py-2 align-middle inline-block min-w-full">
            <div class="shadow border-b border-blue-800 sm:rounded-lg">
            <table class="min-w-full divide-y divide-blue-800">
                <thead class="bg-blue-600 text-xs text-gray-100">
                    <tr>
                        <th class="px-6 py-3 text-left font-medium uppercase tracking-wider">Title</th>
<!--                        <th class="px-6 py-3 text-left font-medium uppercase tracking-wider">Sub-Title</th>-->
                        <th class="px-6 py-3 text-left font-medium uppercase tracking-wider">Category</th>
                        <th class="px-6 py-3 text-left font-medium uppercase tracking-wider">View</th>
                    </tr>
                </thead>
                <tbody class="bg-blue-700 divide-y divide-blue-800 text-gray-200">
                    <tr v-for="deal in deals">
                        <td class="px-6 py-4">
                            <span class="px-2 inline-flex leading-5 font-semibold whitespace-nowrap 2xl:whitespace-normal">
                            {{ deal.name }}
                            </span>
                        </td>
                        <td class="px-6 py-4">
                            <span class="px-2 inline-flex leading-5 font-semibold whitespace-nowrap 2xl:whitespace-normal">
                            {{ deal.quantity }}
                            </span>
                        </td>
                        <td class="px-6 py-4">
                            <span class="px-2 inline-flex leading-5 font-semibold whitespace-nowrap 2xl:whitespace-normal">
                            {{ deal.price }} {{ deal.currency }}
                            </span>
                        </td>
<!--                        <td class="px-6 py-4">-->
<!--                            <span class="px-2 inline-flex leading-5 font-semibold whitespace-nowrap 2xl:whitespace-normal">-->
<!--                            {{ deal.subtitle }}-->
<!--                            </span>-->
<!--                        </td>-->
                        <td class="px-6 py-4">
                            <span v-for="(category, cIndex) in deal.categories">
                            <span>{{ category.name }}</span><span v-if="cIndex+1 < deal.categories.length"> / </span>
                            </span>
                        </td>
                        <td class="px-6 py-4"><a :href="route('deal.show', deal)" class="hover:underline cursor-pointer">View</a></td>
                    </tr>
<!--                    <tr class="bg-blue-800 border border-blue-800 h-16">-->
<!--                        <td class="px-4">50 x Dell Latitude 7480 i5 6th and 7th Gen TAKE ALL @ 195 GBP Per Unit</td>-->
<!--                        <td class="px-4">Notebooks</td>-->
<!--                        <td class="px-4"><span class="hover:underline cursor-pointer">View</span></td>-->
<!--                    </tr>-->
<!--                    <tr class="bg-blue-900 border border-blue-900 h-16">-->
<!--                        <td class="px-4">50 x Apple iPhone 7 TAKE ALL @ 210 GBP Per Unit</td>-->
<!--                        <td class="px-4">Apple</td>-->
<!--                        <td class="px-4"><span class="hover:underline cursor-pointer">View</span></td>-->
<!--                    </tr>-->
                </tbody>
            </table>
        </div>
    </div>
    </div>
    </div>
</template>

<script>

    export default {
        props: {
            deals: {
                required: true,
                type: Array
            }
        }
    }

</script>
